const pluginName = 'authenticationFeedback';
const defaults = {};
const classes = {
  hidden: 'd-none',
  iconDanger: 'fa-exclamation-circle',
  iconSuccess: 'fa-check',
  alertSuccess: 'alert-success',
  alertDanger: 'alert-danger',
};
const selectors = {
  feedbackIcon: '[data-js-authentication-feedback-icon]',
  feedbackText: '[data-js-authentication-feedback-text]',
};

/**
 * Get a nice little package of elements
 * @param $element
 * @returns {Object}
 */
const getElements = ($element) => ({
  $container: $element,
  $feedbackIcon: $element.find(selectors.feedbackIcon),
  $feedbackText: $element.find(selectors.feedbackText),
});

/**
 * Returns the plugin instance data for the element.
 * @param {jQuery} $element The plugin instance element.
 */
const getData = ($element) => $element.data(pluginName);

/**
 * Show the provided content in an alert box
 * @param data
 * @param content
 * @param type
 */
const provide = (data, content, type = 'danger') => {
  data.elements.$feedbackText.html(content);

  if (type === 'danger') {
    data.elements.$container
      .addClass(classes.alertDanger)
      .removeClass(classes.alertSuccess);
    data.elements.$feedbackIcon
      .addClass(classes.iconDanger)
      .removeClass(classes.iconSuccess);
  } else {
    data.elements.$container
      .removeClass(classes.alertDanger)
      .addClass(classes.alertSuccess);
    data.elements.$feedbackIcon
      .removeClass(classes.iconDanger)
      .addClass(classes.iconSuccess);
  }

  data.elements.$container.removeClass(classes.hidden);
};

/**
 * Clear the feedback
 * @param data
 */
const clear = (data) => {
  data.elements.$container
    .addClass(classes.hidden)
    .removeClass(classes.alertDanger)
    .removeClass(classes.alertSuccess);
  data.elements.$feedbackText.empty();
  data.elements.$feedbackIcon
    .removeClass(classes.iconDanger)
    .removeClass(classes.iconSuccess);
};

/**
 * Fires up
 * @param {HTMLElement} element Current element.
 * @param options
 */
const initialize = (element, options) => {
  const $element = $(element);

  if (getData($element)) {
    return;
  }

  const settings = $.extend(true, {}, $.fn[pluginName].defaults, options);
  const elements = getElements($element);
  const data = {
    settings,
    elements,
  };

  data.elements.$container.data(pluginName, data);
};

const methods = {
  provide,
  clear,
};

/**
 * Calls the provided plugin method, passing in the provided parameters if they exist
 * @param element
 * @param method
 * @param parameters
 */
const callPluginMethod = (element, method, ...parameters) => {
  const $element = $(element);
  const data = $element.data(pluginName);

  if (!data) {
    return;
  }

  methods[method](data, ...parameters);
};

/**
 * The plugin for jQuery
 * @param {string|object} methodOrOptions The method as a string or options as an object
 */
const plugin = function Plugin(methodOrOptions, ...methodParameters) {
  if (methods[methodOrOptions]) {
    return this
      .each((index, element) => callPluginMethod(element, methodOrOptions, ...methodParameters));
  }

  if (methodOrOptions === Object(methodOrOptions) || !methodOrOptions) {
    return this.each((index, element) => initialize(element, methodOrOptions));
  }

  return $.error(`Method ${methodOrOptions} does not exist in ${pluginName}`);
};

plugin.defaults = defaults;

$(() => {
  if (plugin in $.fn) {
    return;
  }

  $.extend($.fn, {
    [pluginName]: plugin,
  });
});
